import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { PlusCircle as PlusCircleIcon } from "lucide-react";

const EmptyMessage = ({ message, showAddButton, onAddClick }) => {
  return (
    <Box sx={{ textAlign: 'center', py: 3 }}>
      <Typography color="text.secondary" gutterBottom>
        {message}
      </Typography>
      {showAddButton && (
        <Button variant="text" color="primary" startIcon={<PlusCircleIcon size={16} />} onClick={onAddClick}>
          Add your first item
        </Button>
      )}
    </Box>
  );
};

export default EmptyMessage;
